(function () {
  angular
   .module('kareo.ui.shared.directives.validation.k-unique-user-email', [
     'kareo.ui.shared.modules.api.user.k-user-service',
     'kareo.ui.shared.modules.regex.email'
   ])
   .directive('kUniqueUserEmail', kUniqueUserEmail);

  const defaults = {
    updateOn: 'blur',
    updateOnDefault: true,
    debounce: {
      'default': 300,
      'blur': 0
    }
  };

  kUniqueUserEmail.$inject = ['$q', 'EMAIL_REGEX', 'kUserService'];

  function kUniqueUserEmail($q, EMAIL_REGEX, kUserService) {
    return {
      bindToController: {
        allow: '<?kUniqueUserEmail'
      },
      controller() {},
      controllerAs: 'kUUE',
      restrict: 'A',
      require: 'ngModel',
      link(scope, element, atts, ngModel) {
        ngModel.$options = angular.merge({}, defaults, ngModel.$options);
        ngModel.$asyncValidators.uniqueUserEmail = uniqueUserEmail;

        ngModel.errorMessage = '';

        function uniqueUserEmail(modelValue) {
          if (modelValue === scope.kUUE.allow ||
              ngModel.$isEmpty(modelValue) ||
              !EMAIL_REGEX.test(modelValue)) {
            return $q.when(true);
          }
          return kUserService
            .validateUniqueUserEmail(modelValue)
            .then((response) => {
              ngModel.errorMessage = '';
              return response;
            }, (response) => {
              ngModel.errorMessage = 'Email already in use';
              return $q.reject(response);
            });
        }
      }
    };
  }
})();
